import {City} from './city';

export class Address {
    street:string;
    number:string;
    floor:string;
    department:string;
    zipCode:string;
    city:City = new City(null);

    constructor(other?:Address) {
        if (other) {
            this.street = other.street;
            this.number = other.number;
            this.floor = other.floor;
            this.department = other.department;
            this.zipCode = other.zipCode;
            this.city = other.city;
        }
    }

    public toString() {
        let address = this.street ? this.street.trim() : '';
        let conector = [' ', ', Piso: ', ', Dpto: ', ', CP: ', ', ', ', '];
        address = address.concat(this.number ? (address == '' ? '' : conector[0]) + this.number.trim() : '');
        address = address.concat(this.floor ? (address == '' ? '' : conector[1]) + this.floor.trim() : '');
        address = address.concat(this.department ? (address == '' ? '' : conector[2]) + this.department.trim() : '');
        address = address.concat(this.zipCode ? (address == '' ? '' : conector[3]) + this.zipCode.trim() : '');
        address = address.concat((this.city && this.city.name) ? (address == '' ? '' : conector[4]) + this.city.name.trim() : '');
        address = address.concat((this.city && this.city.state && this.city.state.name) ? (address == '' ? '' : conector[5]) + this.city.state.name.trim() : '');
        return address;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/address.ts
 **/